import { Link } from 'react-router-dom';
import { Ghost, MoonStars, Sun } from 'tabler-icons-react';
import {
  ActionIcon,
  Box,
  Group,
  Header as MantineHeader,
  Tooltip,
  useMantineColorScheme,
  useMantineTheme,
} from '@mantine/core';
import { NotificationMenu } from '../../libs/ui-molecules';
import UserMenu from './UserMenu';
import { useIntlLight } from '../../libs/i18n';
import useAuth from '../../hooks/useAuth';
import { IMG, ROUTE } from '../../types';
import css from './Header.module.css';

export default function Header() {
  const { t } = useIntlLight();
  const theme = useMantineTheme();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const { attestraUser, isImpersonating, loggedIn, exitImpersonation } = useAuth();
  const env = process.env.REACT_APP_ENV;

  return (
    <MantineHeader
      className={env !== 'prod' ? css.dev : ''}
      height={75}
      p="md"
      mb="xl"
      withBorder={false}
    >
      <Box>
        {!loggedIn && (
          <Box className={css.logoWrapper} sx={{ display: 'none' }}>
            <Link to={ROUTE.home}>
              <img className={css.logo} src={IMG.logo} alt="logo" />
            </Link>
          </Box>
        )}
      </Box>
      {env !== 'prod' && (
        <Box>
          <b>{t(`header.env.${env}`)}</b>
          {t('header.env.text')}
        </Box>
      )}
      <Box>
        <Group sx={{ flexWrap: 'nowrap', columnGap: '20px' }}>
          {isImpersonating && (
            <Tooltip label={t('app.impersonation')}>
              <span>
                <Ghost size={28} color={theme.colors.red[7]} onClick={() => exitImpersonation()} />
              </span>
            </Tooltip>
          )}
          <NotificationMenu />
          {!!attestraUser || loggedIn ? (
            <UserMenu />
          ) : (
            <ActionIcon variant="default" onClick={() => toggleColorScheme()} size={30}>
              {colorScheme === 'dark' ? <Sun size={16} /> : <MoonStars size={16} />}
            </ActionIcon>
          )}
        </Group>
      </Box>
    </MantineHeader>
  );
}
